// extracted by mini-css-extract-plugin
export default {"MenuContainer":"onCIoXIT","Menu":"UwDBYfF_"};